import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, autoRehydrate } from "redux-persist";
import createMigration from "redux-persist-migrate";
import immutableTransform from "redux-persist-transform-immutable";
import thunkMiddleware from "redux-thunk";
import ProjectFilters from "~/records/record.projectFilters.jsx";
import UploadedFile from "~/records/record.uploaded_file.jsx";
import { callAPIMiddleware } from "~/store/middleware/call_api_middleware.jsx";
import commentsMiddleware from "~/store/middleware/commentsMiddleware";
import featureFlagsMiddleware from "~/store/middleware/featureFlagsMiddleware";
import notebookMiddleware from "~/store/middleware/notebookMiddleware";
import parseResponseMiddleware from "~/store/middleware/parseResponseMiddleware.jsx";
import projectCountersMiddleware from "~/store/middleware/projectCountersMiddleware.js";
import projectProgressMiddleware from "~/store/middleware/projectProgressMiddleware.js";
import projectTemplateElementsMiddleware from "~/store/middleware/projectTemplateElementsMiddleware.js";
import timestampToStringMiddleware from "~/store/middleware/timestampToStringMiddleware.jsx";
import trackingMiddleware from "~/store/middleware/trackingMiddleware.jsx";
import userDefaultJobTypeIdMiddleware from "~/store/middleware/userDefaultJobTypeIdMiddleware.jsx";
import rootReducer from "~/store/reducers/index.jsx";
import { instance } from "~/utils/urls";
import calendarMiddleware from "./middleware/calendarMiddleware.js";
import workloadMiddleware from "./middleware/workloadMiddleware.js";
import migrateProjectFilters from "./migrations/migrateProjectFilters.jsx";

const manifest = {
  1: (state) => ({ ...state }),
  2: migrateProjectFilters,
};

export default function configureStore(initialState) {
  let middlewares = [
    thunkMiddleware,
    timestampToStringMiddleware,
    callAPIMiddleware,
    trackingMiddleware,
    calendarMiddleware,
    workloadMiddleware,
    projectProgressMiddleware,
    projectCountersMiddleware,
    projectTemplateElementsMiddleware,
    notebookMiddleware,
    commentsMiddleware,
    parseResponseMiddleware,
    userDefaultJobTypeIdMiddleware,
    featureFlagsMiddleware,
  ];

  const composeEnhancers =
    process.env.NODE_ENV === `development` && typeof window === `object` && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares), createMigration(manifest, `app`), autoRehydrate())
  );

  const whitelist = [`app`, `forms`, `uploaded_files`, `projectFilters`, `blocking_interface`];

  persistStore(
    store,
    {
      whitelist,
      keyPrefix: instance ? `user_${instance}_react_state_` : `user_react_state_`,
      debounce: 150,
      transforms: [
        immutableTransform({
          whitelist: [`forms`, `uploaded_files`, `projectFilters`],
          records: [UploadedFile, ProjectFilters],
        }),
      ],
    },
    () => {
      if (process.env.NODE_ENV === `development`) {
        // eslint-disable-next-line
        console.log("Rehydration complete.");
      }
    }
  );

  return store;
}
